import apiClient from './client';
import { ActorSubjectResponseMessage } from '@/types/ActorSubjectResponse';

/**
 * Fetches current actor (user) subject metadata from the server.
 */
export async function fetchActorSubject(): Promise<ActorSubjectResponseMessage> {
  const response = await apiClient.get<ActorSubjectResponseMessage>(
      '/secure/actor/subject',
      {
        // Skip automatic redirect to login on 401, allow public mode
        headers: { 'X-Skip-Auth-Redirect': 'true' },
      }
  );
  return response.data;
}
